import { render, staticRenderFns } from "./couponsIssue.vue?vue&type=template&id=34a9f0a0"
import script from "./couponsIssue.vue?vue&type=script&lang=js"
export * from "./couponsIssue.vue?vue&type=script&lang=js"
import style0 from "./couponsIssue.vue?vue&type=style&index=0&id=34a9f0a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports